import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';

interface JobQuoteExtraSectionProps {
    showModal: boolean;
    crossoverTotal: JobQuoteExtraSection;
    readOnly: boolean;
    update(crossoverTotal: JobQuoteExtraSection): void;
    hideModal(): void;
    saveModal(): void;
}

interface JobQuoteExtraSection {
    totalLength: number;
    crossoverQuantity: number;
    sectionQuantity: number;
    totalCrossoverLength: string;
}


const JobQuoteExtraSectionData = (props: JobQuoteExtraSectionProps) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    const handleChange = (e: any) => {
        setErrors({});

        let item: any = {};
        item = props.crossoverTotal;
        item[e.target.name] = e.target.value;

        props.update(item);
    }

    const handleDrivewayChange = (e: any) => {
        setErrors({});

        var drivewayLength = e.target.value * 1;

        var item = props.crossoverTotal;
        item.totalLength = drivewayLength;

        calculateQuantity(item, drivewayLength);
    }

    const calculateQuantity = (item: JobQuoteExtraSection, drivewayLength: number) => {
        var calcCrossovers = drivewayLength / 4.8;
        var remaining = calcCrossovers % 1;
        if (remaining > 0.68 || calcCrossovers < 1) {
            //round up crossovers
            item.crossoverQuantity = Math.ceil(calcCrossovers);
            item.sectionQuantity = 0;
        } else {
            //add sections
            var crossQty = Math.floor(calcCrossovers);
            item.crossoverQuantity = crossQty;
            var crossLength = crossQty * 4.8;
            var remain = drivewayLength - crossLength;
            var sectionQty = remain / 0.3;
            var sectionRound = Number(sectionQty.toFixed(2));
            item.sectionQuantity = Math.ceil(sectionRound);
        }

        props.update(item);
    }

    const validate = () => {
        var errorList: { [key: string]: string } = {};
        var formIsValid = true;

        if (props.crossoverTotal.totalLength <= 0) {
            formIsValid = false;
            errorList["totalLength"] = "Total Length is required";
        }

        var totalCrossoversSections = props.crossoverTotal.crossoverQuantity + props.crossoverTotal.sectionQuantity;
        if (totalCrossoversSections <= 0) {
            formIsValid = false;
            errorList["totalCrossoversSections"] = "At least one crossover or section is required";
        }

        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            props.saveModal();
        } else {
            toast.error("Please fix validation errors before Saving!");
        }
    }

    return (
        <Modal show={props.showModal} onHide={props.hideModal} backdrop="static">
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Crossover Quantity / Extra Sections</Modal.Title>
                <button type="button" className="close" onClick={props.hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <label className="input-group" htmlFor="quantity">
                    <span className="label">Total Driveway Length (m)</span>
                    <input className="input" min={0} step={0.1} type="number" id="totalLength" name="totalLength" value={props.crossoverTotal.totalLength} onChange={(e) => handleDrivewayChange(e)} disabled={props.readOnly}></input>
                </label>
                <span className={errors["totalLength"] ? "label errors" : "hidden"}>{errors["totalLength"]}</span>

                <label className="input-group" htmlFor="crossoverQuantity">
                    <span className="label">Crossover Quantity (4.8m each)</span>
                    <input className="input" min={1} step={1} type="number" id="crossoverQuantity" name="crossoverQuantity" value={props.crossoverTotal.crossoverQuantity} onChange={(e) => handleChange(e)} disabled={props.readOnly}></input>
                </label>

                <label className="input-group" htmlFor="sectionQuantity">
                    <span className="label">Extra Section Quantity (0.3m each)</span>
                    <input className="input" min={0} step={1} type="number" id="sectionQuantity" name="sectionQuantity" value={props.crossoverTotal.sectionQuantity} onChange={(e) => handleChange(e)} disabled={props.readOnly}></input>
                </label>
                <span className={errors["totalCrossoversSections"] ? "label errors" : "hidden"}>{errors["totalCrossoversSections"]}</span>
                
                <div className="marginLeftLabel">Total Crossover Length: {props.crossoverTotal.totalCrossoverLength}</div>
            </Modal.Body>
            <Modal.Footer>
                <button className={props.readOnly ? "hidden" : "popup-button--yes"} onClick={save}>Calculate</button>
                <button className={props.readOnly ? "popup-button--yes" : "hidden"} onClick={props.hideModal}>Close</button>
            </Modal.Footer>
        </Modal>
    )
}

export default JobQuoteExtraSectionData;